module.exports = __webpack_public_path__ + "static/media/webroll.0eb10c5d.mp4";